document.addEventListener("DOMContentLoaded", function () {
  const MIN_CART_TOTAL = 3.50;
  let lastCartTotal = null;

  function fetchCart(callback) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => callback(cart.total_price / 100))
      .catch(console.error);
  }

  function showWarning(message) {
    let warning = document.getElementById("min-cart-warning");

    if (!warning) {
      warning = document.createElement("div");
      warning.id = "min-cart-warning";
      warning.setAttribute("role", "alert");
      warning.innerHTML = message;

      Object.assign(warning.style, {
        backgroundColor: "#d9edf7",
        color: "#000000",
        border: "1px solid #bce8f1",
        padding: "12px 16px",
        marginBottom: "12px",
        fontSize: "16px",
        borderRadius: "6px",
        fontWeight: "bold",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left",
      });
    }

    const placeholder = document.getElementById("min-cart-warning-placeholder");
    if (placeholder && !document.getElementById("min-cart-warning")) {
      placeholder.appendChild(warning);
    }
  }

  function removeWarning() {
    const existing = document.getElementById("min-cart-warning");
    if (existing) existing.remove();
  }

  function updateButtons(disable) {
    const selectors = [
      '[name="checkout"]',
      '#checkout',
      '.checkout-button',
      '.cart__checkout-button',
      'button[type="submit"]',
      '.btn--checkout',
      '.cart__submit',
      'form[action="/checkout"] button'
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(btn => {
        btn.disabled = disable;
        btn.style.opacity = disable ? "0.5" : "1";
        btn.style.pointerEvents = disable ? "none" : "auto";
      });
    });

    document.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons')
      .forEach(btn => btn.style.display = disable ? 'none' : '');
  }

  function enforceMinimum() {
    fetchCart(total => {
      if (total !== lastCartTotal) {
        lastCartTotal = total;
        if (total < MIN_CART_TOTAL) {
          showWarning(`Due to a rise in fraudulent activity targeting low-cost digital items, customer's carts must be at least $${MIN_CART_TOTAL.toFixed(2)} to proceed to checkout.<p>Apologies! Thanks for understanding.</p>`);
          updateButtons(true);
        } else {
          removeWarning();
          updateButtons(false);
        }
      }
    });
  }

  if (window.location.pathname === '/cart') {
    enforceMinimum();

    const cartContainer = document.querySelector('form[action="/cart"]') || document.body;
    cartContainer.addEventListener('change', () => setTimeout(enforceMinimum, 500));
    cartContainer.addEventListener('click', () => setTimeout(enforceMinimum, 500));

    setInterval(enforceMinimum, 1000);
  }
});
